import CubusService from '@/cubus/services/cubusService'

export default function initCubus() {
  const cubusService = new CubusService()

  return {
    cubusService,
  }
}
